import { MessageCodeEnum } from '~/constants/MessageCode';
import { ClientError } from '~/error/ClientError';
import { FileRepository } from '~/repository/FileRepository';

export const useFile = (displayId: string) => {
  const fileRepository = new FileRepository(displayId);

  /**
   * 利用規約PDFを別タブで開く
   *
   * @param isPrivate 非公開のPDFを対象とするかどうか
   */
  const openTermsOfServicePdfInNewTab = async (isPrivate: boolean) => {
    let pdf: Blob;
    if (isPrivate) {
      pdf = await fileRepository.getPrivatePdf('terms_of_service');
    }
    else {
      pdf = await fileRepository.getPublicPdf('terms_of_service');
    }

    _openPdfInNewTab(pdf);
  };

  /**
   * FAQのPDFを別タブで開く
   */
  const openFaqPdfInNewTab = async () => {
    const pdf = await fileRepository.getPrivatePdf('faq');
    _openPdfInNewTab(pdf);
  };

  /**
   * 操作マニュアルPDFを別タブで開く
   */
  const openSiteDescriptionPdfInNewTab = async () => {
    const pdf = await fileRepository.getPrivatePdf('site_description');
    _openPdfInNewTab(pdf);
  };

  /**
   * 駅マップPDFを別タブで開く
   *
   * 駅コード未指定の場合は、作業駅の駅マップを表示する
   *
   * @param stationCd 駅コード
   * @param stationSubCd 社線駅サブコード
   */
  const openStationMapPdfInNewTab = async (stationCd?: string, stationSubCd?: string) => {
    let targetStationCd = stationCd;
    let targetStationSubCd = stationSubCd;

    if (!targetStationCd) {
      const { loginUser } = useLoginUserStore();
      if (!loginUser?.workingStation) {
        throw new ClientError(MessageCodeEnum.WORKING_STATION_IS_NOT_SET, displayId);
      }

      targetStationCd = loginUser.workingStation.stationCd;
      targetStationSubCd = loginUser.workingStation.stationSubCd;
    }

    const pdf = await fileRepository.getStationMap(targetStationCd, targetStationSubCd ?? '');
    _openPdfInNewTab(pdf);
  };

  /**
   * PDFを別タブで開く
   *
   * @param pdf PDFファイル
   */
  const _openPdfInNewTab = (pdf: Blob) => {
    const url = URL.createObjectURL(pdf);
    window.open(url, '_blank');
  };

  return {
    openTermsOfServicePdfInNewTab,
    openFaqPdfInNewTab,
    openSiteDescriptionPdfInNewTab,
    openStationMapPdfInNewTab,
  };
};
